import React, { FC, useState } from "react";
import styled from "styled-components";

import { JS } from "../constants";
import { imageSrcSet } from "../helpers/images";
import { usePlayerStore } from "../store/usePlayerStore";

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
`;

const Img = styled.img`
  display: block;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute;
  transition: opacity 0.2s ease-in-out;
  width: 100%;
`;

export const PreviewImage: FC = () => {
  const { useStoreState } = usePlayerStore();
  const aspectRatio = useStoreState.aspectRatio();
  const mediaData = useStoreState.media();
  const playerUiWidth = useStoreState.uiSizeInPx();

  const srcSet = mediaData
    ? imageSrcSet({
        aspectRatio,
        id: mediaData.image.id,
        serviceId: mediaData.serviceId
      })
    : "";

  const [opacity, setOpacity] = useState(0);

  return (
    <Wrapper>
      <Img
        alt=""
        className={JS.IMAGE_CLASS}
        key={srcSet}
        sizes={playerUiWidth ? `${playerUiWidth.toFixed()}px` : "100vw"}
        srcSet={srcSet}
        style={{ opacity }}
        onLoad={() => setOpacity(1)}
      />
    </Wrapper>
  );
};
